import { useState } from 'react';
// @mui
import { Box, IconButton, MenuItem, Stack } from '@mui/material';
// components
import MenuPopover from '../menu-popover';
import useLocales from '../../locales/useLocales';

// ----------------------------------------------------------------------

// Only show languages with complete translations
const SUPPORTED_LANGS = ['de', 'en'];

export default function LanguagePopover() {
  const { currentLang, allLangs, onChangeLang } = useLocales();

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const filteredLangs = allLangs.filter((lang) => SUPPORTED_LANGS.includes(lang.value));

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang: string) => {
    onChangeLang(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButton
        onClick={handleOpenPopover}
        sx={{
          width: 40,
          height: 40,
          ...(openPopover && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <Box
          component="img"
          src={currentLang.icon}
          alt={currentLang.label}
          sx={{ width: 28, height: 20, borderRadius: 0.5 }}
        />
      </IconButton>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 180 }}>
        <Stack spacing={0.75}>
          {filteredLangs.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={() => handleChangeLang(option.value)}
            >
              <Box
                component="img"
                src={option.icon}
                alt={option.label}
                sx={{ width: 28, height: 20, borderRadius: 0.5, mr: 1 }}
              />
              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
